import axios from "axios";

const apiBaseURL = (typeof config === "undefined" ? process.env.VUE_APP_TBD_BACKEND_URL : config.VUE_CONFIG_TBD_API || process.env.VUE_APP_TBD_BACKEND_URL)

const request = axios.create({
  baseURL: apiBaseURL,
  withCredentials: false,
  timeout: 60000
})

export function getSynonymTFNameCodes(tfNameCode) {
  const params = { tf_name_code: tfNameCode }
  return request({
    url: "/synonym-tf-name-codes",
    method: "get",
    params
  })
}
